import { useEffect, useState } from 'preact/hooks';
import type { SupabaseClient } from '@supabase/supabase-js';
import { generarRespaldo, marcarRespaldo, ultimoRespaldo } from '../datos/respaldo';
import { AMBIENTE } from '../supabase';
import { nf } from '../logica/dinero';
import { hoy } from '../logica/fechas';
import { fechaLarga } from '../logica/pedidos';
import { estadoRespaldo, nombreArchivoRespaldo } from '../logica/respaldo';
import { descargar } from './Clientes';

// Respaldo: un Excel con todos los datos, una hoja por tabla, para guardar en la carpeta privada.
export function Respaldo({ sb }: { sb: SupabaseClient }) {
  const [ultimo, setUltimo] = useState<string | null | undefined>(undefined), [trabajando, setTrabajando] = useState(false), [error, setError] = useState(''), [aviso, setAviso] = useState('');
  useEffect(() => { ultimoRespaldo(sb).then(setUltimo).catch(e => setError(String(e.message || e))); }, []);
  const est = estadoRespaldo(ultimo ?? null, hoy(), true);
  const bajar = async () => {
    setError(''); setAviso(''); setTrabajando(true);
    try {
      const fecha = hoy(), r = await generarRespaldo(sb, fecha, AMBIENTE);
      descargar(nombreArchivoRespaldo(AMBIENTE, fecha), r.libro, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
      await marcarRespaldo(sb, fecha); setUltimo(fecha);
      setAviso(`Respaldo descargado: ${r.hojas} hojas y ${nf(r.filas)} filas. Guárdalo en la carpeta privada.`);
    } catch (e) { setError('No se pudo preparar el respaldo: ' + String((e as Error).message || e)); }
    setTrabajando(false);
  };
  return (
    <section class="panel form-sec" aria-label="Respaldo">
      <h3>Respaldo de tus datos</h3>
      <p class="hint">Descarga un Excel con todo lo que hay en el sistema: pedidos, clientes, productos, precios, fórmulas, compras, gastos, campañas y ajustes, una hoja por tabla. La primera hoja (LEEME) dice cuántas filas trae cada una.</p>
      {ultimo === undefined ? <p class="hint">Cargando…</p>
        : <p class={est.toca ? 'nota' : 'okline'} role="status">{ultimo ? `Último respaldo: ${fechaLarga(ultimo)} (${est.dias === 0 ? 'hoy' : `hace ${est.dias} ${est.dias === 1 ? 'día' : 'días'}`}).` : 'Todavía no has descargado ningún respaldo.'}{est.toca ? ' Ya toca descargar otro.' : ''}</p>}
      <div><button class="btn primary" type="button" disabled={trabajando} onClick={bajar}>{trabajando ? 'Preparando el respaldo…' : 'Descargar respaldo'}</button></div>
      {aviso && <p class="okline" role="status">{aviso}</p>}
      {error && <p class="errbox" role="alert">{error}</p>}
      <ul class="hint lista-simple">
        <li><strong>Cada cuánto:</strong> una vez al mes y antes de cualquier cambio grande.</li>
        <li><strong>Dónde guardarlo:</strong> en la carpeta privada (por ejemplo iCloud Drive → Talentino → Respaldos). Trae nombres y teléfonos de clientes y datos de cuentas bancarias: no se comparte ni se sube al repositorio.</li>
        <li><strong>Qué no trae:</strong> las fotos de los dibujos. Están en el depósito de imágenes y el archivo trae sus rutas.</li>
        <li><strong>Para qué sirve:</strong> para poder reconstruir los datos si algo falla. No se restaura con un clic. En producción, Supabase además hace una copia diaria automática.</li>
      </ul>
    </section>
  );
}
